"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesTasksByIdPatchAsyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../../api/index.js");
const actions_1 = require("../../_idMap/actions.js");
exports.coreInitiativesTasksByIdPatchAsyncSlice = (0, xuder_1.createPatchAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (_a) => {
                var { initiativeId, taskId } = _a, rest = __rest(_a, ["initiativeId", "taskId"]);
                return (0, actions_1.updateInitiativeReferences)([
                    {
                        initiativeId: initiativeId,
                        tasks: {
                            toUpdateById: {
                                id: taskId,
                                update: rest
                            }
                        }
                    }
                ]);
            }
        ]
    },
    name: name_1.CoreInitiativesTasksByIdName,
    receive: false,
    request: true,
    requestHandler: _api_1.patchInitiativeTask
});
//# sourceMappingURL=patch.js.map